import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { useState } from "react";
import {
    Button,
    IconButton,
    MenuItem,
    Select,
    SelectChangeEvent,
    TextField,

} from "@mui/material";
import { useNavigate } from "react-router-dom";
import IosSwitchMain from "../../components/iosSwitchMain";

function AddExceptionalGuest() {
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };
    const [isGuest, setisGuest] = useState(false);
    const [value, setValue] = React.useState({
        page: "0",
        type: "0",
        type1: "0",
    });
    const handleChange1 = (event: SelectChangeEvent) => {
        const { name, value } = event.target;
        setValue((prev) => ({
            ...prev,
            [name]: value,
        }));
    };
    return (
        <>
            <MainContainer>
                <div className="main_title d_flex">
                    <div className="left_s">
                        <h1 className="back_arrow">
                            {" "}
                            <IconButton onClick={() => goBack()}>
                                {" "}
                                <ArrowBackIcon />{" "}
                            </IconButton>{" "}
                            Add Exceptional User
                        </h1>
                    </div>
                </div>
                <div className="cards add_user_link">
                    <div className="gap_p">
                        <div className="control_group w_50">
                            <TextField
                                variant="outlined"
                                placeholder="Add no. of Guests"
                                fullWidth
                                hiddenLabel
                            // InputProps={{ readOnly: true }}
                            />
                        </div>
                        <div className="control_group cncl_plcy w_50">
                            <label>Add Guest Details</label>
                            <IosSwitchMain
                                checked={isGuest}
                                onChange={(e) => setisGuest(e.target.checked)}
                            />
                        </div>
                        {isGuest && (
                            <>
                                <div className="gap_p">
                                    <div className="control_group w_33">
                                        <TextField
                                            variant="outlined"
                                            placeholder="Email"
                                            fullWidth
                                            hiddenLabel
                                        />
                                    </div>
                                    <div className="control_group w_33">
                                        <TextField
                                            variant="outlined"
                                            placeholder="Name"
                                            fullWidth
                                            hiddenLabel
                                        />
                                    </div>
                                    <div className="control_group w_33">
                                        <TextField
                                            variant="outlined"
                                            placeholder="Dietary Requirement"
                                            fullWidth
                                            hiddenLabel

                                        />
                                    </div>
                                    <div className="control_group w_33">
                                        <Select
                                            className="dropse"
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            inputProps={{
                                                "aria-label": "Without label",
                                            }}
                                            displayEmpty
                                            name="type"
                                            value={value.type}
                                            onChange={handleChange1}
                                        >
                                            <MenuItem value="0" disabled>
                                                Select Payar
                                            </MenuItem>
                                            <MenuItem value="10">Samantha</MenuItem>
                                            <MenuItem value="20">John</MenuItem>
                                            <MenuItem value="20">Guest</MenuItem>
                                        </Select>
                                    </div>
                                </div>

                            </>
                        )}
                        <div className="mt_30">
                            <Button className="btn btn_primary">Save</Button>
                        </div>
                    </div>
                </div>
            </MainContainer></>
    )
}
export default AddExceptionalGuest;